import { useMemo } from 'react';

import { Project } from 'types';

import { useSelectedProjectId } from './use-selected-project-id';

export const useFilteredProjects = (projects: Project[]) => {
  const { selectedProjectId } = useSelectedProjectId();

  return useMemo(
    () =>
      selectedProjectId
        ? projects.filter((p) => p.id === selectedProjectId)
        : projects,
    [projects, selectedProjectId]
  );
};
